const APP_NAME = "Axe Food";
// const BASE_URL = import.meta.env.VITE_API_URL + "/api/";
// const BASE_URL = "http://127.0.0.1:8000/api/"/;
const BASE_URL = "https://api.axefood.org/api/";

const LOCAL_STORAGE_KEYS = {
  THEME_KEY: "dark_mode",
  LANG_KEY: "locale",
  AUTH_TOKEN_KEY: "token",
  AUTH_USER_INFO: "user_info",
};

export { APP_NAME, BASE_URL, LOCAL_STORAGE_KEYS };
